import React, { useEffect } from "react";
import "assets/components/CardBlog.scss";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import {
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
  Button,
  Link,
} from "@mui/material";
import { KeyboardDoubleArrowRightOutlined } from "@mui/icons-material";
import { useState } from "react";
import "assets/components/BlogDetail.scss";

const CardBlog = (props) => {
  const [idSlug, setIdSlug] = useState(true);
  const [plainText, setPlainText] = useState("");

  useEffect(() => {
    let safeSlug = props.slug ? props.slug : props.id;

    safeSlug = safeSlug.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    safeSlug = safeSlug.replace(/[^a-zA-Z0-9-_]/g, "-").toLowerCase();

    setIdSlug(safeSlug);

    const parseHTML = (html) => {
      const doc = new DOMParser().parseFromString(html, "text/html");
      return doc.body.textContent || "";
    };

    setPlainText(parseHTML(props.content || ""));
  }, [props.content, props.id, props.slug]);

  return (
    <>
      <Card className="CardBlog card-blog-container">
        <CardMedia
          sx={{ height: 140 }}
          image={
            props.featured_image
              ? `data:image/png;base64,${props.featured_image}`
              : ""
          }
        />
        <CardContent>
          <Typography
            component="h2"
            variant="inherit"
            sx={{
              fontSize: "18px",
              fontWeight: 500,
              mb: "10px",
              color: "#20305B",
            }}
          >
            <Link
              href={`/b/${idSlug}`}
              underline="hover"
              color="inherit"
              title={props.title}
              aria-label={`Leggi l'articolo: ${props.title}`}
            >
              {props.title}
            </Link>
          </Typography>

          <Typography
            className="textDescriptionCard"
            variant="body2"
            color="text.secondary"
          >
            {plainText && plainText.length > 130
              ? plainText.slice(0, 130) + "..."
              : plainText}
          </Typography>
        </CardContent>
        <CardActions
          sx={{
            position: "absolute",
            bottom: 0,
            right: 0,
          }}
        >
          <Link
            href={`/b/${idSlug}`}
            size="small"
            title={props.title}
            aria-label={`Leggi l'articolo: ${props.title}`}
          >
            Leggi{" "}
            <KeyboardDoubleArrowRightOutlined
              style={{ fontSize: "16px", marginLeft: "4px" }}
            />
          </Link>
        </CardActions>
      </Card>
    </>
  );
};

export default CardBlog;
